export enum DealerCompetitionActionType {
  Delete = 'Delete',
  End = 'End',
  DeleteDraft = 'DeleteDraft',
}
